import home from "@/assets/home-hero.avif";
import homeSmall from "@/assets/home-hero-640.avif";
import nieuwbouw from "@/assets/nieuwbouw-hero.avif";
import nieuwbouwSmall from "@/assets/nieuwbouw-hero-640.avif";
import renovatie from "@/assets/renovatie-hero.avif";
import renovatieSmall from "@/assets/renovatie-hero-640.avif";
import overOns from "@/assets/over-ons-hero.avif";
import overOnsSmall from "@/assets/over-ons-hero-640.avif";
import warmtepompen from "@/assets/warmtepompen-hero.avif";
import home640 from "@/assets/performance/home-640.avif.asset.json";
import home1024 from "@/assets/performance/home-1024.avif.asset.json";
import nieuwbouw640 from "@/assets/performance/nieuwbouw-640.avif.asset.json";
import nieuwbouw1024 from "@/assets/performance/nieuwbouw-1024.avif.asset.json";
import renovatie640 from "@/assets/performance/renovatie-640.avif.asset.json";
import renovatie1024 from "@/assets/performance/renovatie-1024.avif.asset.json";
import overOns640 from "@/assets/performance/over-ons-640.avif.asset.json";
import overOns1024 from "@/assets/performance/over-ons-1024.avif.asset.json";
import warmtepompen640 from "@/assets/performance/warmtepompen-640.avif.asset.json";
import warmtepompen1024 from "@/assets/performance/warmtepompen-1024.avif.asset.json";
import blog480 from "@/assets/performance/blog-upload-480.avif.asset.json";
import blog800 from "@/assets/performance/blog-upload-800.avif.asset.json";
import blog1280 from "@/assets/performance/blog-upload-1280.avif.asset.json";
import aanleg480 from "@/assets/performance/stappenplan-aanleg-480.avif.asset.json";
import aanleg800 from "@/assets/performance/stappenplan-aanleg-800.avif.asset.json";
import aanleg1280 from "@/assets/performance/stappenplan-aanleg-1280.avif.asset.json";
import pomp480 from "@/assets/performance/warmtepomp-480.avif.asset.json";
import pomp800 from "@/assets/performance/warmtepomp-800.avif.asset.json";
import pomp1280 from "@/assets/performance/warmtepomp-1280.avif.asset.json";
import groen480 from "@/assets/performance/groen-water-480.avif.asset.json";
import groen800 from "@/assets/performance/groen-water-800.avif.asset.json";
import groen1280 from "@/assets/performance/groen-water-1280.avif.asset.json";

interface Variant { url: string; width: number; height: number }
const pair = (small: { url: string }, large: { url: string }): Variant[] => [
  { url: small.url, width: 640, height: 360 },
  { url: large.url, width: 1024, height: 576 },
];
const articleVariants = (small: { url: string }, medium: { url: string }, large: { url: string }): Variant[] => [
  { url: small.url, width: 480, height: 270 },
  { url: medium.url, width: 800, height: 450 },
  { url: large.url, width: 1280, height: 720 },
];

/** Explicit same-image aliases only; never synthesize URLs for unknown uploads. */
export const optimizedImageVariants: Record<string, Variant[]> = {
  [home]: pair(home640, home1024),
  [homeSmall]: pair(home640, home1024),
  [nieuwbouw]: pair(nieuwbouw640, nieuwbouw1024),
  [nieuwbouwSmall]: pair(nieuwbouw640, nieuwbouw1024),
  [renovatie]: pair(renovatie640, renovatie1024),
  [renovatieSmall]: pair(renovatie640, renovatie1024),
  [overOns]: pair(overOns640, overOns1024),
  [overOnsSmall]: pair(overOns640, overOns1024),
  [warmtepompen]: pair(warmtepompen640, warmtepompen1024),
  "/api/public/blog-image/1d6e2b14-0611-44ff-b198-0d468256adb5.webp": articleVariants(blog480, blog800, blog1280),
  "/blog/stappenplan-aanleg.avif": articleVariants(aanleg480, aanleg800, aanleg1280),
  "/blog/warmtepomp.avif": articleVariants(pomp480, pomp800, pomp1280),
  "/blog/groen-water.avif": articleVariants(groen480, groen800, groen1280),
};